import tippy from 'tippy.js';

const findFrame = element => element.closest('[data-component="field-mapping-frame"]');

const findRowActions = frame => frame.querySelector('[data-component="preview-row-actions"]');

const setHovered = (frame, fileRow, hovered) => {
    frame.querySelectorAll(`[data-file-row="${fileRow}"]`).forEach(cell => {
        cell.classList.toggle('row-hovered', hovered);
    });
};

const updateSkipTooltip = (skipButton, fileRow) => {
    const content = (skipButton.dataset.skipTemplate ?? '').replace('%d', String(fileRow + 1));

    if (skipButton._tippy) {
        skipButton._tippy.setContent(content);
    } else {
        tippy(skipButton, {content});
    }
};

const positionRowActions = (rowActions, frame, cell, fileRow) => {
    const framePosition = frame.getBoundingClientRect();
    const cellPosition  = cell.getBoundingClientRect();

    rowActions.style.top = `${cellPosition.top - framePosition.top}px`;
    rowActions.style.height = `${cellPosition.height}px`;
    rowActions.dataset.fileRow = fileRow;
    rowActions.removeAttribute('hidden');

    const skipButton = rowActions.querySelector('.preview-row-action');

    if (!skipButton) {
        return;
    }

    skipButton.setAttribute('hx-vals', JSON.stringify({skipRows: fileRow + 1}));
    updateSkipTooltip(skipButton, fileRow);
};

const showRowActions = (frame, cell, fileRow) => {
    const rowActions = findRowActions(frame);

    if (!rowActions) {
        return;
    }

    positionRowActions(rowActions, frame, cell, fileRow);
};

const hideRowActions = frame => {
    findRowActions(frame)?.setAttribute('hidden', '');
};

export const handlePreviewMouseOver = event => {
    const cell = event.target.closest?.('.preview-cell');

    if (!cell || cell.dataset.fileRow === undefined) {
        return;
    }

    const frame = findFrame(cell);

    if (!frame) {
        return;
    }

    setHovered(frame, cell.dataset.fileRow, true);
    showRowActions(frame, cell, Number.parseInt(cell.dataset.fileRow, 10));
};

// Covers both "leaving a cell" and "leaving the row-actions": hide the actions and
// unhover the row, unless the mouse is heading to another element in the same row.
export const handlePreviewMouseOut = event => {
    const hoverable = event.target.closest?.('.preview-cell, [data-component="preview-row-actions"]');

    if (!hoverable || hoverable.dataset.fileRow === undefined) {
        return;
    }

    const frame = findFrame(hoverable);

    if (!frame) {
        return;
    }

    const fileRow = hoverable.dataset.fileRow;
    const next    = event.relatedTarget?.closest?.('.preview-cell, [data-component="preview-row-actions"]');

    if (next) {
        if (next.matches('.preview-cell') && next.dataset.fileRow === fileRow) {
            return;
        }

        if (next.matches('[data-component="preview-row-actions"]')) {
            return;
        }
    }

    setHovered(frame, fileRow, false);
    hideRowActions(frame);
};
